import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#limit-length" }),
  /*#__PURE__*/_createTextVNode(" Limit length ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { style: {"margin":"20px 0"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_input, {
        type: "text",
        placeholder: "Please input",
        modelValue: _ctx.text,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.text = $event)),
        maxlength: "10",
        "show-word-limit": ""
      }, null, 8, ["modelValue"]),
      _hoisted_4,
      _createVNode(_component_el_input, {
        type: "textarea",
        placeholder: "Please input",
        modelValue: _ctx.textarea,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.textarea = $event)),
        maxlength: "30",
        "show-word-limit": ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code13), 1)
        ]),
        _: 1
      })
    ])
  ]))
}